import common from "../common";
import Scene from "./Scene";

export default class SendDataScene extends Scene 
{
    constructor()
    {
        super('sendData');

        this.dataTries = 0;
    }

    init()
    {
        if(!common.basicMode)
        {
            common.boardGraphicGenerator.getPixelsFromImage(common.baseUrl + 'assets/images/boards/world_united.png', (pixelData) => {
                MEDIATOR.pcApp.setBoardImage(common.boardGraphicGenerator.restrictColours(pixelData, common.boardGraphicGenerator.textRestrictedColours));
            });
        }

        this.sendData();
        //this.signals.next.dispatch();
    }

    sendData()
    {
        var data = {};

        for(var i in common.response)
        {
            data[i] = common.response[i];

            if(i == 'phone')
                data[i] = common.config.areacodes[common.response.country] + data[i];
            if(i == 'favouriteManUtdPlayer')
                data[i] = String(data[i]);
        }
        console.log(data);

        var that = this;

        
        $.ajax({
            type: "POST",
            url: "https://inmotion.dhl/" + common.country + "/manchester-united/a-world-united/submit",
            //url: "https://inmotioncms.adrivo.com/" + common.country + "/manchester-united/a-world-united/submit",
            data: data,
            success: (result) => 
            {
                console.log(result);
                common.seatNumber = result.seat_number;
                this.signals.next.dispatch();

                window.parent.postMessage({name: 'campaign_submit', detail: {existing: result.existing_entry}}, 'https://inmotion.dhl');
            },
            error: () => {
                that.dataTries++;
                if(that.dataTries < 10)
                {
                    setTimeout(that.sendData.bind(that), 2000);
                }
            }
        });
    }

}